<div class="udex-grid" aria-live="assertive">
  <div class="row justify-content-center">
    <div class="text-center" aria-hidden="true">
      <img alt="" src="/images/configurator/checkout-unavailable-error.png" />
    </div>
  </div>
  <div class="row justify-content-center">
    <div class="col-sm-10 col-md-9 udex-mt-40">
      <p class="text-center body--s">{{ errorMsgMainText }}</p>
    </div>
  </div>
  <div class="row justify-content-center">
    <div class="col-12 col-sm-6 col-md-5">
      <table class="body--xs udex-mt-12">
        <tbody>
          <tr>
            <td class="udex-py-8">{{ errorMsgTheadText }}</td>
            <td class="udex-py-8 navigation__medium--m">{{ errorInfo.currentCartCurrency }}</td>
          </tr>
          <tr class="udex-py-8">
            <td class="udex-py-8">{{ errorInfo.addedItem }} ({{ errorInfo.addedItemAID }})</td>
            <td class="udex-py-8 navigation__medium--m">{{ errorInfo.addedItemCurrency }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="row justify-content-center">
    <udex-button
      #viewCartButton
      class="udex-button udex-button--wide udex-mt-20 udex-mb-24"
      (click)="redirectToCart()"
      size="Large"
      design="Primary"
      >{{ 'configurator.errorMessage.btnText' | cxTranslate }}</udex-button
    >
  </div>
</div>
